export const queryKeys = {
  HOUSE_COMPACT_V2_PARAM: 'HOUSE_COMPACT_V2_PARAM'
};
